// AUTO-GENERATED from ./currencies.ts — do not edit by hand.
// Lean client-safe subset of the currency dataset: exactly what money
// FORMATTING needs (display symbol + ISO 4217 minor-unit digits). The full
// `CURRENCIES` records (names, flags, country codes, native symbols) are
// picker/back-office data — importing them from formatting code shipped the
// whole ~28KB table to every storefront visitor. Keep the two in sync by
// regenerating this file whenever currencies.ts changes:
//   npx tsx -e "..." (see packages/shared/README or the generating commit).

export const CURRENCY_FORMAT_DATA: Readonly<
  Record<string, readonly [symbol: string, decimalDigits: number]>
> = {
  AED: ["د.إ", 2],
  AFN: ["؋", 2],
  ALL: ["L", 2],
  AMD: ["֏", 2],
  ANG: ["ƒ", 2],
  AOA: ["Kz", 2],
  ARS: ["$", 2],
  AUD: ["$", 2],
  AWG: ["ƒ", 2],
  AZN: ["₼", 2],
  BAM: ["KM", 2],
  BBD: ["$", 2],
  BDT: ["৳", 2],
  BGN: ["лв", 2],
  BHD: [".د.ب", 3],
  BIF: ["Fr", 0],
  BMD: ["$", 2],
  BND: ["$", 2],
  BOB: ["Bs.", 2],
  BRL: ["R$", 2],
  BSD: ["$", 2],
  BTN: ["Nu.", 2],
  BWP: ["P", 2],
  BYN: ["Br", 2],
  BYR: ["Br", 2],
  BZD: ["$", 2],
  CAD: ["$", 2],
  CDF: ["Fr", 2],
  CHF: ["CHF", 2],
  CLP: ["$", 0],
  CNY: ["¥", 2],
  COP: ["$", 2],
  CRC: ["₡", 2],
  CUC: ["$", 2],
  CUP: ["$", 2],
  CVE: ["$", 2],
  CZK: ["Kč", 2],
  DJF: ["Fr", 0],
  DKK: ["DKK", 2],
  DOP: ["RD$", 2],
  DZD: ["د.ج", 2],
  EGP: ["EGP", 2],
  ERN: ["Nfk", 2],
  ETB: ["Br", 2],
  EUR: ["€", 2],
  FJD: ["$", 2],
  FKP: ["£", 2],
  GBP: ["£", 2],
  GEL: ["₾", 2],
  GGP: ["£", 2],
  GHS: ["₵", 2],
  GIP: ["£", 2],
  GMD: ["D", 2],
  GNF: ["Fr", 0],
  GTQ: ["Q", 2],
  GYD: ["$", 2],
  HKD: ["$", 2],
  HNL: ["L", 2],
  HRK: ["kn", 2],
  HTG: ["G", 2],
  HUF: ["Ft", 2],
  IDR: ["Rp", 2],
  ILS: ["₪", 2],
  IMP: ["£", 2],
  INR: ["₹", 2],
  IQD: ["ع.د", 3],
  IRR: ["﷼", 2],
  IRT: ["تومان", 2],
  ISK: ["kr.", 0],
  JEP: ["£", 2],
  JMD: ["$", 2],
  JOD: ["د.ا", 3],
  JPY: ["¥", 0],
  KES: ["KSh", 2],
  KGS: ["сом", 2],
  KHR: ["៛", 2],
  KMF: ["Fr", 0],
  KPW: ["₩", 2],
  KRW: ["₩", 0],
  KWD: ["د.ك", 3],
  KYD: ["$", 2],
  KZT: ["₸", 2],
  LAK: ["₭", 2],
  LBP: ["ل.ل", 2],
  LKR: ["රු", 2],
  LRD: ["$", 2],
  LSL: ["L", 2],
  LYD: ["ل.د", 3],
  MAD: ["د.م.", 2],
  MDL: ["MDL", 2],
  MGA: ["Ar", 2],
  MKD: ["ден", 2],
  MMK: ["Ks", 2],
  MNT: ["₮", 2],
  MOP: ["P", 2],
  MRO: ["UM", 2],
  MUR: ["₨", 2],
  MVR: [".ރ", 2],
  MWK: ["MK", 2],
  MXN: ["$", 2],
  MYR: ["RM", 2],
  MZN: ["MT", 2],
  NAD: ["$", 2],
  NGN: ["₦", 2],
  NIO: ["C$", 2],
  NOK: ["kr", 2],
  NPR: ["₨", 2],
  NZD: ["$", 2],
  OMR: ["ر.ع.", 3],
  PAB: ["B/.", 2],
  PEN: ["S/.", 2],
  PGK: ["K", 2],
  PHP: ["₱", 2],
  PKR: ["₨", 2],
  PLN: ["zł", 2],
  PRB: ["р.", 2],
  PYG: ["₲", 0],
  QAR: ["ر.ق", 2],
  RON: ["lei", 2],
  RSD: ["дин.", 2],
  RUB: ["₽", 2],
  RWF: ["Fr", 0],
  SAR: ["ر.س", 2],
  SBD: ["$", 2],
  SCR: ["₨", 2],
  SDG: ["ج.س.", 2],
  SEK: ["kr", 2],
  SGD: ["$", 2],
  SHP: ["£", 2],
  SLL: ["Le", 2],
  SOS: ["Sh", 2],
  SRD: ["$", 2],
  SSP: ["£", 2],
  STD: ["Db", 2],
  SYP: ["ل.س", 2],
  SZL: ["L", 2],
  THB: ["฿", 2],
  TJS: ["ЅМ", 2],
  TMT: ["m", 2],
  TND: ["د.ت", 3],
  TOP: ["T$", 2],
  TRY: ["₺", 2],
  TTD: ["$", 2],
  TWD: ["NT$", 2],
  TZS: ["Sh", 2],
  UAH: ["₴", 2],
  UGX: ["UGX", 0],
  USD: ["$", 2],
  UYU: ["$", 2],
  UZS: ["UZS", 2],
  VEF: ["Bs F", 2],
  VND: ["₫", 0],
  VUV: ["Vt", 0],
  WST: ["T", 2],
  XAF: ["CFA", 0],
  XCD: ["$", 2],
  XOF: ["CFA", 0],
  XPF: ["Fr", 0],
  YER: ["﷼", 2],
  ZAR: ["R", 2],
  ZMW: ["ZK", 2],
};

/** All supported ISO 4217 codes (uppercase) — lean sibling of
 *  `CURRENCY_CODES` in ./currencies.ts, for modules that must not drag the
 *  full picker dataset into client bundles. */
export const LEAN_CURRENCY_CODES: readonly string[] =
  Object.keys(CURRENCY_FORMAT_DATA);

/** Lean sibling of `isSupportedCurrency` in ./currencies.ts. */
export function isSupportedCurrencyLean(code: string): boolean {
  return Object.prototype.hasOwnProperty.call(
    CURRENCY_FORMAT_DATA,
    code.toUpperCase(),
  );
}
